import { Button, Stack, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { SuccessCheckCircle } from "web_myplann/Shared/Components/SuccessCheckCircle";
import { SUCCESS_MYPLANN_LIGHT } from "web_myplann/Utils/constants";

const PageResources = Resources.Goals.Detail.Solution.Pin.New.Success;

type Props = {
	onBackToGoal: () => void;
	onFillDetails: () => void;
};

export const NewContractSuccess: FC<Props> = ({
	onBackToGoal,
	onFillDetails,
}) => {
	const { palette, spacingTokens } = useTheme();
	const { t } = useResource();

	return (
		<Stack px={spacingTokens.lg} pb={spacingTokens.lg} gap={spacingTokens.xxl}>
			<Stack alignItems="center" textAlign="center" gap={spacingTokens.md}>
				<SuccessCheckCircle
					color={SUCCESS_MYPLANN_LIGHT}
					bgcolor={alpha(SUCCESS_MYPLANN_LIGHT, 0.2)}
				/>
				<Typography variant="h3">{t(PageResources.title)}</Typography>
				<Typography variant="body2" color={palette.grey[500]}>
					{t(PageResources.description)}
				</Typography>
				<Typography variant="hint">{t(PageResources.note)}</Typography>
			</Stack>
			<Stack gap={spacingTokens.sm}>
				<Button variant="primary" onClick={onBackToGoal}>
					{t(PageResources.backToGoal)}
				</Button>
				<Button
					variant="textLink"
					onClick={onFillDetails}
					sx={{ justifyContent: "center", py: spacingTokens.sm }}
				>
					{t(PageResources.fillDetails)}
				</Button>
			</Stack>
		</Stack>
	);
};
